import React from 'react';
import Link from 'next/link';
import { useTranslations } from '../../locales/useTranslations';
import { BiNetworkChart, BiEnvelope, BiLayer, BiCheck } from 'react-icons/bi';

const ManagedServicesServiceCards = () => {
  const { t } = useTranslations();
  const zeroTrustPoints = [1, 2, 3].map((n) => t(`managedServices_card_zeroTrustVpn_point${n}`));
  const mailPoints = [1, 2, 3].map((n) => t(`managedServices_card_mailServer_point${n}`));
  const comingPoints = [1, 2, 3, 4].map((n) => t(`managedServices_card_coming_point${n}`));

  return (
    <section className="ms-section ms-section--services">
      <div className="container">
        <div className="ms-section-header ms-section-header--center">
          <span className="ms-section__badge">{t('managedServices_services_badge')}</span>
          <h2 className="ms-section__title">{t('managedServices_services_title')}</h2>
          <p className="ms-section__lead ms-section__lead--center">
            {t('managedServices_services_subtitle')}
          </p>
        </div>
        <div className="row align-items-stretch mb-4">
          <div className="col-lg-6 mb-4 mb-lg-0">
            <div className="ms-service-card ms-service-card--featured h-100">
              <span className="ms-service-card__featured-label">{t('managedServices_card_zeroTrustVpn_label')}</span>
              <div className="ms-service-card__icon">
                <BiNetworkChart />
              </div>
              <h3 className="ms-service-card__title">{t('managedServices_card_zeroTrustVpn_title')}</h3>
              <p className="ms-service-card__desc">{t('managedServices_card_zeroTrustVpn_desc')}</p>
              <ul className="ms-service-card__highlights">
                {zeroTrustPoints.map((line, i) => (
                  <li key={i}>
                    <BiCheck aria-hidden />
                    <span>{line}</span>
                  </li>
                ))}
              </ul>
              <Link href="/managed-services/zerotrustvpn/" className="ms-header__btn-primary ms-service-card__btn">
                {t('managedServices_card_zeroTrustVpn_cta')}
              </Link>
            </div>
          </div>
          <div className="col-lg-6 mb-4 mb-lg-0">
            <div className="ms-service-card ms-service-card--featured h-100">
              <span className="ms-service-card__featured-label">{t('managedServices_card_mailServer_label')}</span>
              <div className="ms-service-card__icon">
                <BiEnvelope />
              </div>
              <h3 className="ms-service-card__title">{t('managedServices_card_mailServer_title')}</h3>
              <p className="ms-service-card__desc">{t('managedServices_card_mailServer_desc')}</p>
              <ul className="ms-service-card__highlights">
                {mailPoints.map((line, i) => (
                  <li key={i}>
                    <BiCheck aria-hidden />
                    <span>{line}</span>
                  </li>
                ))}
              </ul>
              <Link href="/managed-services/business-mail/" className="ms-header__btn-primary ms-service-card__btn">
                {t('managedServices_card_mailServer_cta')}
              </Link>
            </div>
          </div>
        </div>
        <div className="row justify-content-center">
          <div className="col-lg-8">
            <div className="ms-service-card ms-service-card--muted ms-service-card--coming">
              <div className="ms-service-card__icon">
                <BiLayer />
              </div>
              <span className="ms-service-card__label">{t('managedServices_card_coming_label')}</span>
              <h3 className="ms-service-card__title">{t('managedServices_card_coming_title')}</h3>
              <p className="ms-service-card__desc">{t('managedServices_card_coming_desc')}</p>
              <ul className="ms-service-card__highlights ms-service-card__highlights--muted">
                {comingPoints.map((line, i) => (
                  <li key={i}>
                    <span className="ms-service-card__dot" aria-hidden />
                    <span>{line}</span>
                  </li>
                ))}
              </ul>
              <Link href="/kontakt/" className="ms-service-card__link">
                {t('managedServices_cta_button')} →
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ManagedServicesServiceCards;
